import { CellPlugin } from '@react-page/editor';
import React from 'react';
import { Col, Row } from 'react-bootstrap';

// use a type here, not an interface
type Data = {
  label: string,
  value: string
}

const getValue = (value: string) => {
  if (value && value.length > 0) {
    return value.replace(/\D/g, "").replace(/(\d{3})(\d{3})(\d{1,4})/, "($1) $2-$3");
  } else {
    return "(555) 555-5555";
  }
}

const PhoneNumberPropertyPlugin: CellPlugin<Data> = {
  Renderer: ({ data }) => (
      <Row>
        <Col><strong>{data.label}</strong></Col>
        <Col>{getValue(data.value)}</Col>
      </Row>
  ),
  id: 'phoneNumberPropertyPlugin',
  title: 'Phone Number Property',
  description: 'Phone Number Property.',
  version: 1,
  controls: {
    type: 'autoform',
    schema: {
      properties: {
        label: {
          type: 'string',
          default: 'Phone Number Name',
        },
      },
      required: ['label'],
    },
  },
};

export default PhoneNumberPropertyPlugin;